import styled, { css } from 'styled-components';
import type { Project } from 'Common/hooks/useFilters';

import scrollbarStyle from 'Common/styles/scrollbar';

export const TabsWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        border-bottom: ${theme.commonStyles.brandPixel} solid ${theme.colors.secondary.tints[1].hex};
        margin-bottom: 1rem;

        @media ${theme.breakpoints.large.media} {
            margin-bottom: 3rem;
        }
    `}
`;

export const TabList = styled.div`
    ${scrollbarStyle()}
    white-space: nowrap;
    overflow-x: auto;
    scroll-behavior: smooth;
`;

export const TabButton = styled.button<{ $isActive: boolean; $project: Project }>`
    ${({ theme, $isActive, $project }) => css`
        background: ${theme.colors.primaryContrast.hex};
        border: none;
        padding: 1.5rem 1rem;

        &:hover {
            background: ${theme.colors.secondary.tints[1].hex};
            cursor: pointer;
        }

        ${$isActive &&
        css`
            border-bottom: 0.25rem solid ${theme.modules.siteSearch[$project].colour};
        `}
    `}
`;

export const FiltersDesktop = styled.div`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.large.media} {
            display: block;
            padding-left: 1rem;
        }
    `}
`;

export const FiltersMobile = styled.div`
    ${({ theme }) => css`
        @media ${theme.breakpoints.large.media} {
            display: none;
        }
    `}
`;

export const FilterHeading = styled.h2`
    ${({ theme }) => css`
        font-size: 1.125rem;
        font-weight: 400;
        line-height: 1;
        margin: 0;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.25rem;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 1.5rem;
            line-height: 3.35;
        }
    `}
`;

export const CheckboxList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0 0 0.75rem;
`;
